import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { BrowseContext } from '../../../contexts/BrowseContext'
import RecentCampaignCard from './RecentCampaignCard'

export default observer(function RecentlyOpenedCampaignsList() {
  const { recentlyOpenedCampaigns } = useContext(BrowseContext)
  return (
    <div className='p-8 pb-0 w-full'>
      <h2 className='font-bold text-lg mb-2 dark:text-white'>Recently Visited</h2>
      <div className='w-full overflow-hidden'>
        <div className='flex flex-nowrap gap-1 overflow-x-auto pb-4'>
          {recentlyOpenedCampaigns.map(campaign => ( <RecentCampaignCard key={campaign.id} campaign={campaign} /> ))}
        </div>
      </div>
    </div>
  )
})